<template>
  <div class="pill" :class="classNames" @click="$emit('click', $event)"><slot /><Icon v-if="$listeners.remove" name="times" @click="$emit('remove', $event)" /></div>
</template>

<script>
import Icon from './Icon'
export default {
  name: 'Pill',
  components: {
    Icon
  },
  props: {
    danger: Boolean,
    success: Boolean,
    warning: Boolean,
    info: Boolean,
    small: Boolean
  },
  computed: {
    classNames () {
      const classes = []
      if (this.success) classes.push('success')
      if (this.danger) classes.push('danger')
      if (this.warning) classes.push('warning')
      if (this.info) classes.push('info')
      if (this.small) classes.push('small')
      if (this.$listeners.click) classes.push('clickable')
      return classes
    }
  }
}
</script>

<style lang="scss">
.pill {
  background: var(--gray);
  padding: 0.4rem 0.6rem;
  border-radius: var(--border-radius);
  display: inline-block;

  &.small {
    padding: 0.1rem 0.6rem;
    font-size: 70%;
  }

  &.success {
    background: var(--success-color);
    color: #fff;
  }

  &.warning {
    background: var(--warning-color);
    color: #fff;
  }

  &.danger {
    background: var(--danger-color);
    color: #fff;
  }

  &.info {
    background: var(--primary-color);
    color: #fff;
  }

  &.clickable {
    cursor: pointer;
  }

  .icon {
    margin-left: 0.5rem;
    cursor: pointer;
  }
}
</style>
